import {Boundary} from "./boundary";
import {Vector3} from "three";
import {HBEWallDefaultThickness} from "../../../../globals";
import {toFixedFloat} from "../../../../utils/utils";

export class SupportBeam extends Boundary {
    constructor(sceneObject) {
        super(sceneObject);

        //Wände verlängern ihre Bounds, damit Eckknoten entstehen. Unterzüge liegen nur bündig aneinander,
        //deshalb muss dieselbe Verlängerung hier nachgezogen werden, sonst erkennt der Raumloop vier Beams nicht.
        let expandVector = new Vector3(0, 0, 0);
        if (this.orientation === "x") {
            expandVector.setX(HBEWallDefaultThickness);
        } else {
            expandVector.setZ(HBEWallDefaultThickness);
        }

        this.boundingBox = this.boundingBox.expandByVector(expandVector);

        this.boundingBox.min.setX(toFixedFloat(this.boundingBox.min.x));
        this.boundingBox.max.setX(toFixedFloat(this.boundingBox.max.x));
        this.boundingBox.min.setZ(toFixedFloat(this.boundingBox.min.z));
        this.boundingBox.max.setZ(toFixedFloat(this.boundingBox.max.z));
    }
}
